export const avatar = {
   light: {
      avatarWithText: {
         default: {
            backgroundColor: 'bg-gray-100'
         }
      },
      avatarWithUserIcon: {
         default: {
            backgroundColor: 'bg-gray-100'
         }
      }
   },
   dark: {}
}
